import React, { Component } from 'react'
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";
import FomeList from './FomeList';
import { Button, message } from 'antd';
import moment from 'moment';


export default class Cover extends Component {
    state = {
        params: {},
        type: 'view',
        approvalUserOption: [],
    };

    componentDidMount() {
        const { clinicalQuotationRecordId, evaluateRecordId } = this.props;
        this.loadData(clinicalQuotationRecordId, evaluateRecordId);
    }

    componentWillReceiveProps(nextProps) {
        const { clinicalQuotationRecordId, evaluateRecordId } = nextProps;
        this.loadData(clinicalQuotationRecordId, evaluateRecordId);
    }

    loadData = (clinicalQuotationRecordId,evaluateRecordId) => {
        if (!(clinicalQuotationRecordId && evaluateRecordId)) return
        const options = {
            method: 'POST',
            url: API_URL.evaluate.getQuotationCover,
            data: { 
                clinicalQuotationRecordId,
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                const { quotationCover } = res;
                const { planFormulationDate, validityPeriodDate } = quotationCover;
                this.setState({
                    params: {
                        ...quotationCover,
                        planFormulationDate: planFormulationDate ? moment(planFormulationDate).format('YYYY-MM-DD') : undefined,
                        validityPeriodDate: validityPeriodDate ? moment(validityPeriodDate).format('YYYY-MM-DD') : undefined,
                    },
                })
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        if (key == 'approvalUser') {
            const { value: id, text } = value;
            params[`${key}Id`] = id;
            params[`${key}Compellation`] = text;
        } else {
            params[key] = value;
        }
        this.setState({ params });
    };

    submit = () => {
        const { clinicalQuotationRecordId, evaluateRecordId } = this.props;
        const { params } = this.state;
        const { planFormulationDate, validityPeriodDate } = params;
        const queryData = JSON.parse(JSON.stringify(params));
        const Config = this.handleDomRender();
        try {
            Config.map(el => {
                const { name, label, type, required = false, show = true } = el;
                if(required && show) { 
                    if(type === 'SearchRetrieve') {
                        if( !params[`${name}Id`] || !params[`${name}Compellation`]) {
                            throw label
                        }
                    } else if( !queryData[name] ) {
                        throw label
                    }
                }
            });
        } catch (error) {
            message.warning(`请填写${error}！`);
            return false
        }
        const options = {
            method: 'POST',
            url: API_URL.evaluate.updateQuotationCover,
            data: { 
                ...params,
                planFormulationDate: planFormulationDate ? moment(planFormulationDate).format('YYYY-MM-DD') : undefined,
                validityPeriodDate: validityPeriodDate ? moment(validityPeriodDate).format('YYYY-MM-DD') : undefined,
                clinicalQuotationRecordId,
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    type: 'view',
                }, () => this.loadData(clinicalQuotationRecordId, evaluateRecordId))
            }
        };
        $.sendRequest(options);
    }

    handleDomRender = () => {
        const Config = [
            {
                label: '服务类型',
                name: 'serverType',
                type: 'Input',
                required: true,
                typeProperty: {
                    style: { width: 180 },
                },
            },
            {
                label: '方案编号',
                name: 'evaluateSerialNumber',
                type: 'text',
                required: true,
            },
            {
                label: '提交对象',
                name: 'submitObject',
                type: 'text',
            },
            {
                label: '地址',
                name: 'address',
                type: 'text',
            },
            {
                label: '联系人',
                name: 'contactPerson',
                type: 'text',
            },
            {
                label: '电话',
                name: 'mobile',
                type: 'text',
            },
            {
                label: '提交方',
                name: 'submittingParty',
                type: 'Input',
                required: true,
                typeProperty: {
                    style: { width: 180 },
                },
            },
            {
                label: '地址',
                name: 'submitterAddress',
                type: 'Input',
                required: true,
                typeProperty: {
                    style: { width: 180 },
                },
            },
            {
                label: '电话',
                name: 'submitterMobile',
                type: 'Input',
                required: true,
                typeProperty: {
                    style: { width: 180 },
                },
            },
            {
                label: '计划书制定日期',
                name: 'planFormulationDate',
                type: 'text',
                required: false,
            },
            {
                label: '报价版本号',
                name: 'quoteVersionNumber',
                type: 'text',
            },
            {
                label: 'BA',
                name: 'baName',
                type: 'text',
                required: false,
            },
            {
                label: 'BD',
                name: 'bdName',
                type: 'text',
                required: false,
            },
            {
                label: '审批人',
                name: 'approvalUser',
                showName: 'approvalUserCompellation',
                type: 'SearchRetrieve',
                required: true,
                typeProperty: {
                    keyword: "keyword",
                    placeholder: "输入姓名/工号检索",
                    params: { limit: 20 },
                    url: API_URL.team.userlist,
                    config: {id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user'},
                },
            },
            {
                label: '有效期至(30天)',
                name: 'validityPeriodDate',
                required: false,
                type: 'text',
            },
            {
                label: 'CRM ID',
                name: 'crmId',
                type: 'text',
            },
        ];
        return Config
    }

    render() {
        const { params, type } = this.state;
        const { clinicalQuotationRecordId, evaluateRecordId, recordData } = this.props;
        const { bdBaAuth, evaluateStatus } = recordData;
        return (
            <div>
                <div style={{ fontSize: 20, fontWeight: 600, textAlign: 'center', margin: '20px 0' }}>
                    SMO服务计划书
                </div>
                <FomeList
                    params={params}
                    updateType={type}
                    handleChange={this.handleChange}
                    DomConfig={this.handleDomRender()}
                    style={{ marginBottom: 25 }}
                />
                {
                    (bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') && <div className='Forecast_Params_footer'>
                        {
                            type === 'view'?
                            <Button 
                                type="primary"
                                onClick={() => this.setState({
                                    type: 'edit',
                                })}
                            >编辑</Button> :
                            <div>
                                <Button 
                                    style={{ marginRight: 20 }}
                                    onClick={() => this.setState({
                                        type: 'view',
                                    }, () => this.loadData(clinicalQuotationRecordId, evaluateRecordId))}
                                >取消</Button>
                                <Button 
                                    type="primary"
                                    onClick={this.submit}
                                >确定</Button>
                            </div>
                        }
                    </div>
                }
            </div>
            
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/Cover.js